import Session from '@/util/session';
import Ajax from '@/plugins/ajax';

export default {
    get() {
        const me = this;
        return new Promise(function (resolve, reject) {
            const session = Session.get();
            if (Session.valid() && session.account) {
                resolve(session);
            } else {
                Ajax({
                    url: "/api/auth/info"
                }).then(function (res) {
                    if (res.success) {
                        resolve(me.set(res.data));
                    } else {
                        reject(res);
                    }
                });
            }
        });
    },
    /**
     * auth信息写入本地缓存
     * 
     * @param {*} authData 
     */
    set(authData) {
        const token = authData.token,
            account = authData.account, appId = authData.appId,
            session = Object.assign(token, {
                account,
                appId
            });
        Session.set(session);
        return session;
    }
}
